import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  RELEVANCE_FILTER_I18N_PREFIX as MY_I18N_PREFIX,
  RELEVANCE_FILTER_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/RelevanceFilteri18nConstants';
import {
  RELEVANT_RADIO_BUTTON_ID,
  RELEVANT_RADIO_BUTTON_NAME,
  RELEVANT_OPTION_VALUE,
  IRRELEVANT_RADIO_BUTTON_ID,
  IRRELEVANT_RADIO_BUTTON_NAME,
  IRRELEVANT_OPTION_VALUE
} from './constants/RelevanceFilterConstants';


export class RelevanceFilter extends Component {

  static propTypes = {
    relevanceFilterOption: PropTypes.string.isRequired,
    handleRelevanceFilterSelection: PropTypes.func.isRequired,
    toggleIfCommentFilterIsActive: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isRelevanceFilterDropdownOpen: true
    };
    this.wrapperRef = React.createRef();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getI18nText(textKey){
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  toggleRelevanceFilterIsActive= () => {  
    this.setState(prevState => {
      return { isRelevanceFilterDropdownOpen: !prevState.isRelevanceFilterDropdownOpen };
    });
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isRelevanceFilterDropdownOpen: false });
    }
  }

  render() {
    const {
      isRelevanceFilterDropdownOpen
    } = this.state;

    return ( 
      <div>
        <div
          className={`input-container-relevance-filter ${isRelevanceFilterDropdownOpen ? 'active' : ''}`}
          ref={this.wrapperRef}
        >
          <div
            className="relevance-filter-dropdown"
            onClick={() => this.toggleRelevanceFilterIsActive()}
          >
            <div className='relevance-filter-placeholder'>{this.getI18nText(MY_I18N_KEYS.relevance_filter_button_label)}</div>
            <i className={`la la-${isRelevanceFilterDropdownOpen ? 'minus' :'plus'}`} />
          </div>
        </div>
        {isRelevanceFilterDropdownOpen && (
          <div className='relevance-filter-content'>
            <label htmlFor={RELEVANT_RADIO_BUTTON_ID}>
              <input 
                type="radio" 
                id={RELEVANT_RADIO_BUTTON_ID}
                value={RELEVANT_OPTION_VALUE}
                name={RELEVANT_RADIO_BUTTON_NAME}
                checked={this.props.relevanceFilterOption === RELEVANT_OPTION_VALUE}
                onChange={this.props.handleRelevanceFilterSelection}
                onClick={this.props.toggleIfCommentFilterIsActive}
              /> {this.getI18nText(MY_I18N_KEYS.relevance_filter_option)}
            </label>
            <label htmlFor={IRRELEVANT_RADIO_BUTTON_ID}>
              <input 
                type="radio" 
                id={IRRELEVANT_RADIO_BUTTON_ID}
                value={IRRELEVANT_OPTION_VALUE} 
                name={IRRELEVANT_RADIO_BUTTON_NAME}
                checked={this.props.relevanceFilterOption === IRRELEVANT_OPTION_VALUE}
                onChange={this.props.handleRelevanceFilterSelection}
                onClick={this.props.toggleIfCommentFilterIsActive}
              /> {this.getI18nText(MY_I18N_KEYS.irrelevance_filter_option)}
            </label> 
          </div>
        )}
      </div>
    )
  }
}

export default RelevanceFilter;


// WEBPACK FOOTER //
// ./src/features/home/components/comment-filter/RelevanceFilter.js